import { defineMessages } from 'react-intl';

type MessageKeys = 'browseAgentsPillLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> = defineMessages({
	browseAgentsPillLabel: {
		id: 'ai-mate.rovo-agent-components.browse-agents-pill.label',
		defaultMessage: 'Browse agents',
		description: 'The label displayed on the browse agents pill',
	},
});

export default message;
